export const useCanUseRecording = (): boolean => true;
